import { render, staticRenderFns } from "./ErrorFlashModal.vue?vue&type=template&id=2dfa2ed0"
import script from "./ErrorFlashModal.vue?vue&type=script&lang=js"
export * from "./ErrorFlashModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports